/**
 * Created by m.igrachev on 7/20/2017.
 */
import getLocale from "./getLocale";
import guessDecimalSeparator from "./guessDecimalSeparator";
import replaceAll from "../string/replaceAll";

export default function unifyDecimalString(decimalString, options) {
    //The unified decimal string does not contain " " or "," and its separator is "."!
    let unified = decimalString;
    let defaultedLocale = getLocale(options.locale);
    let separator = guessDecimalSeparator(defaultedLocale);
    let separators = [separator];
    if (options.additionalSeparator) {
        separators.push(options.additionalSeparator);
    }
    let space32 = String.fromCharCode(32);
    let space160 = String.fromCharCode(160);
    let space8239 = String.fromCharCode(8239); //fr thousands separator
    let spaces = [space32, space160, space8239];
    let expectedSymbols = spaces.concat([",", "."]);
    for (let expectedSymbol of expectedSymbols) {
        if (!separators.includes(expectedSymbol)) {
            if (!spaces.includes(expectedSymbol)) {
                let sequentialExpectedSymbol = expectedSymbol + expectedSymbol;
                //Note that we forbid sequentialExpectedSymbol but ' ' are considered ok!
                if (decimalString.includes(sequentialExpectedSymbol)) {
                    return null;
                }
                //Do not allow hundreds separator after decimal separator!
                if (
                    decimalString.includes(separator) &&
                    decimalString.includes(expectedSymbol) &&
                    decimalString.lastIndexOf(separator) < decimalString.lastIndexOf(expectedSymbol)
                ) {
                    return null;
                }
            }

            //This is why we "love" regular expressions! - escape the escape symbol! How powerful is that!!!
            unified = replaceAll(unified, expectedSymbol, "");
        }
    }

    //Test for more than one separator
    let hasMoreThanOneSeparator = false;
    for (let s of separators) {
        let splitUnified = unified.split(s);
        if (splitUnified.length > 2) hasMoreThanOneSeparator = true;
    }
    if (hasMoreThanOneSeparator) {
        return null;
    }

    return unified.replace(separator, ".");
}
